import { FC, useEffect, useState } from 'react';
import { Button } from 'components/shadcn/button';
import DefaultModal from 'components/Shared/DefaultModal';
import { RadioGroup, RadioGroupItem } from 'components/shadcn/radioGroup';
import { useLanguage } from 'languages/languageContext';

interface NotifyModalProps {
  open: boolean;
  type: 'change' | 'reminder' | '';
  onSelect: (option: string) => void;
  onClose: () => void;
  isEventHaveMembers: number;
  eventLabels: any;
}

const NotifyModal: FC<NotifyModalProps> = ({ open, type, onSelect, onClose, isEventHaveMembers, eventLabels }) => {
  const [selected, setSelected] = useState<string>('');
  const { btn } = useLanguage();

  useEffect(() => {
    if (type === 'reminder') {
      setSelected('no');
    } else if (type === 'change') {
      setSelected(isEventHaveMembers === 0 ? 'nobody' : 'confirmed');
    }
  }, [type, open, isEventHaveMembers]);

  const handleOk = () => {
    if (selected === 'confirmed' && isEventHaveMembers === 0) {
      return;
    }
    onSelect(selected);
  };

  return (
    <DefaultModal
      showModal={open}
      onClose={onClose}
      modalTitle={type === 'change' ? eventLabels.eventChangedModal.title : eventLabels.eventReminder.title}
      message={type === 'change' ? eventLabels.eventChangedModal.subTitle : (
        <>
          <span>{eventLabels.eventReminder.subTitleFirstPart}</span>
          <span style={{ fontWeight: 'bold' }}>{eventLabels.eventReminder.not}</span>
          <span>{eventLabels.eventReminder.subTitleSecondPart}</span>
        </>
      )}
    >
      <div className="flex flex-col items-center w-full">
        {type === 'change' ? (
          <>
            <RadioGroup value={selected} onValueChange={setSelected} className="w-full mb-4">
              <div className="flex items-center space-x-2 px-4 py-2">
                <RadioGroupItem value="all" id="notify-all" />
                <label htmlFor="notify-all">{eventLabels.eventChangedModal.allInvited}</label>
              </div>
              <div className={`flex items-center space-x-2 px-4 py-2 ${isEventHaveMembers === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}>
                <RadioGroupItem 
                  value="confirmed" 
                  id="notify-confirmed" 
                  disabled={isEventHaveMembers === 0}
                />
                <label 
                  htmlFor="notify-confirmed"
                  className={isEventHaveMembers === 0 ? 'cursor-not-allowed' : ''}
                >
                  {isEventHaveMembers > 0 ? eventLabels.eventChangedModal.onlyConfirmed : eventLabels.eventChangedModal.noConfirmationsYet}
                </label>
              </div>
              <div className="flex items-center space-x-2 px-4 py-2">
                <RadioGroupItem value="not_confirmed" id="notify-not-confirmed" />
                <label htmlFor="notify-not-confirmed">{eventLabels.eventChangedModal.onlyNotConfirmed}</label>
              </div>
              <div className="flex items-center space-x-2 px-4 py-2">
                <RadioGroupItem value="nobody" id="notify-nobody" />
                <label htmlFor="notify-nobody">{eventLabels.eventChangedModal.nobody}</label>
              </div>
            </RadioGroup>
            <Button onClick={handleOk} className="w-[90%]">
              {selected === 'nobody' ? btn.saveAndCloseBtn : btn.saveAndSendBtn}
            </Button>
          </>
        ) : (
          <>
            <RadioGroup value={selected} onValueChange={setSelected} className="w-full mb-4">
              <div className="flex items-center space-x-2 px-4 py-2">
                <RadioGroupItem value="all" id="reminder-all" />
                <label htmlFor="reminder-all">{eventLabels.eventReminder.allinvited}</label>
              </div>
              <div className={`flex items-center space-x-2 px-4 py-2 ${isEventHaveMembers === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}>
                <RadioGroupItem 
                  value="confirmed" 
                  id="notify-confirmed" 
                  disabled={isEventHaveMembers === 0}
                />
                <label 
                  htmlFor="notify-confirmed"
                  className={isEventHaveMembers === 0 ? 'cursor-not-allowed' : ''}
                >
                  {isEventHaveMembers > 0 ? eventLabels.eventChangedModal.onlyConfirmed : eventLabels.eventChangedModal.noConfirmationsYet}
                </label>
              </div>
              <div className="flex items-center space-x-2 px-4 py-2">
                <RadioGroupItem value="not_confirmed" id="reminder-not-confirmed" />
                <label htmlFor="reminder-not-confirmed">{eventLabels.eventReminder.onlyNotConfirmed}</label>
              </div>
              <div className="flex items-center space-x-2 px-4 py-2">
                <RadioGroupItem value="no" id="reminder-no" />
                <label htmlFor="reminder-no">{eventLabels.eventReminder.no}</label>
              </div>
            </RadioGroup>
            <Button onClick={handleOk} className="w-[90%]">
              {selected === 'no' ? btn.saveAndCloseBtn : btn.saveAndSendBtn}
            </Button>
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default NotifyModal;
